import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";


const ProductCard = ({ product, handleAddToCart }) => {

  return (
    
    <Card className="card">
      <CardMedia
        component="img"
        height="280"

        image={product.image}
        alt={product.name}
      />
      <CardContent >
        <Stack spacing={1}>
          <Typography variant="h6" color="text.primary">
              {product.name}
          </Typography>
          <Typography className="dollars">
              ${product.cost}
          </Typography>
          <Rating name="half-rating-read" defaultValue={product.rating} precision={0.5} readOnly></Rating>
          <br/>
          <Button variant="outlined" className="card-button" onClick={handleAddToCart}><AddShoppingCartOutlined/> ADD TO CART</Button>

        </Stack>
             </CardContent>
    </Card>
  );
};

export default ProductCard;
